export default __webpack_public_path__ + "static/view-groups-dark-mode-caebb1c2bc586bae395109c49842b9dd.png";